export enum CookFollowUpEnum {
    COOK_NOT_RESPONDING = "Cook not responding",
    COOK_IS_FACING_ISSUES = "Cook is facing issues",
    COOK_IS_NOT_GOING = "Cook is not going",
    COOK_IS_GOING = "Cook is going",
    OTHER = "Other"
}